<template>
  <Layout>
    <div class="media-slot-list">
      <div class="page-header">
        <div>
          <h2>媒体代码位</h2>
          <p>管理广告投放媒体渠道</p>
        </div>
        <el-button type="primary" @click="addDialogVisible = true">
          添加代码位
        </el-button>
      </div>
      
      <!-- 筛选条件 -->
      <el-card shadow="never" class="filter-container">
        <el-form :inline="true" :model="filterForm" class="filter-form">
          <el-form-item label="媒体平台">
            <el-select v-model="filterForm.platform" placeholder="选择平台" clearable>
              <el-option v-for="item in platformOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告类型">
            <el-select v-model="filterForm.adType" placeholder="选择类型" clearable>
              <el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="filterForm.keyword" placeholder="输入代码位名称关键词"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 媒体代码位列表 -->
      <el-table
        v-loading="loading"
        :data="filteredMediaSlots"
        border
        style="width: 100%; margin-top: 20px;">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="slotId" label="代码位ID" min-width="180"></el-table-column>
        <el-table-column prop="name" label="代码位名称" min-width="150"></el-table-column>
        <el-table-column prop="platform" label="媒体平台" width="120">
          <template slot-scope="scope">
            <el-tag :type="getPlatformTagType(scope.row.platform)">
              {{ getPlatformName(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="adType" label="广告类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="getAdTypeTagType(scope.row.adType)">
              {{ getAdTypeName(scope.row.adType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-value="active"
              inactive-value="inactive"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="toggleStatus(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalMediaSlots">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑代码位对话框 -->
      <el-dialog
        :title="isEdit ? '编辑媒体代码位' : '添加媒体代码位'"
        :visible.sync="addDialogVisible"
        width="600px">
        <el-form :model="mediaSlotForm" :rules="rules" ref="mediaSlotForm" label-width="100px">
          <el-form-item label="代码位名称" prop="name">
            <el-input v-model="mediaSlotForm.name" placeholder="输入代码位名称"></el-input>
          </el-form-item>
          
          <el-form-item label="代码位ID" prop="slotId">
            <el-input-number 
              v-model="mediaSlotForm.slotId" 
              :min="1"
              controls-position="right"
              style="width: 100%"
              :disabled="!isEdit"
              placeholder="编辑时可修改代码位ID">
            </el-input-number>
            <div class="el-form-item__tip">系统自动生成整数ID，编辑时可修改</div>
          </el-form-item>
          
          <el-form-item label="媒体平台" prop="platform">
            <el-select v-model="mediaSlotForm.platform" placeholder="选择媒体平台" style="width: 100%">
              <el-option v-for="item in platformOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="广告类型" prop="adType">
            <el-select v-model="mediaSlotForm.adType" placeholder="选择广告类型" style="width: 100%">
              <el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="mediaSlotForm.status">
              <el-radio label="active">启用</el-radio>
              <el-radio label="inactive">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="媒体配置" prop="config">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="输入媒体接口所需的JSON配置（可选）"
              v-model="mediaSlotForm.config">
            </el-input>
            <div class="el-form-item__tip">用于存储媒体平台特定的配置信息（JSON格式）</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitMediaSlot">确 定</el-button>
        </span>
      </el-dialog>
      
      <!-- 删除确认对话框 -->
      <el-dialog
        title="确认删除"
        :visible.sync="deleteDialogVisible"
        width="400px">
        <p>确定要删除代码位 "{{ currentMediaSlot.name }}" 吗？</p>
        <p class="warn-text">此操作不可恢复！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="danger" @click="confirmDelete">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { mapState, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'MediaSlotList',
  components: {
    Layout
  },
  data() {
    return {
      filterForm: {
        platform: '',
        adType: '',
        keyword: ''
      },
      addDialogVisible: false,
      deleteDialogVisible: false,
      isEdit: false,
      currentMediaSlot: {},
      mediaSlotForm: {
        id: '',
        name: '',
        platform: '',
        adType: '',
        slotId: '',
        bidFloor: 0,
        status: 'active',
        config: '',
        createTime: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入代码位名称', trigger: 'blur' }
        ],
        platform: [
          { required: true, message: '请选择媒体平台', trigger: 'change' }
        ],
        adType: [
          { required: true, message: '请选择广告类型', trigger: 'change' }
        ],
        slotId: [
          { type: 'number', message: '代码位ID必须是数字', trigger: 'change' },
          { type: 'number', min: 1, message: '代码位ID必须大于0', trigger: 'change' }
        ]
      },
      platformOptions: [
        { value: 'tencent', label: '腾讯广告' },
        { value: 'bytedance', label: '字节跳动' },
        { value: 'baidu', label: '百度联盟' },
        { value: 'kuaishou', label: '快手' },
        { value: 'alibaba', label: '阿里妈妈' },
        { value: 'xiaomi', label: '小米广告' },
        { value: 'oppo', label: 'OPPO广告' },
        { value: 'vivo', label: 'vivo广告' },
        { value: 'huawei', label: '华为广告' },
        { value: 'sohu', label: '搜狐' },
        { value: 'meishu', label: '美数' },
        { value: 'shunfei', label: '舜飞' },
        { value: 'zhangyue', label: '掌阅' },
        { value: 'wifi_key', label: 'Wifi万能钥匙' },
        { value: 'xiaohongshu_article', label: '小红书软广' },
        { value: 'wechat_article', label: '公众号软广' },
        { value: 'self_media_article', label: '自媒体软广' },
        { value: 'portal_article', label: '门户媒体软广' },
        { value: 'other', label: '其他平台' }
      ],
      adTypeOptions: [
        { value: 'banner', label: '横幅广告' },
        { value: 'native', label: '信息流广告' },
        { value: 'interstitial', label: '插屏广告' },
        { value: 'rewarded_video', label: '激励视频' },
        { value: 'splash', label: '开屏广告' },
        { value: 'draw', label: 'Draw信息流' },
        { value: 'soft_article', label: '软文广告' }
      ],
      currentPage: 1,
      pageSize: 30
    }
  },
  computed: {
    ...mapState(['mediaSlots', 'loading']),
    filteredMediaSlots() {
      let result = [...this.mediaSlots]
      
      // 按媒体平台筛选
      if (this.filterForm.platform) {
        result = result.filter(item => item.platform === this.filterForm.platform)
      }
      
      // 按广告类型筛选
      if (this.filterForm.adType) {
        result = result.filter(item => item.adType === this.filterForm.adType)
      }
      
      // 按关键词筛选
      if (this.filterForm.keyword) {
        const keyword = this.filterForm.keyword.toLowerCase()
        result = result.filter(item => 
          (item.name && item.name.toLowerCase().includes(keyword)) ||
          (item.slotId && String(item.slotId).toLowerCase().includes(keyword))
        )
      }
      
      // 分页处理
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      
      return result.slice(startIndex, endIndex)
    },
    totalMediaSlots() {
      // 总数量计算（考虑筛选条件）
      let result = [...this.mediaSlots]
      
      if (this.filterForm.platform) {
        result = result.filter(item => item.platform === this.filterForm.platform)
      }
      
      if (this.filterForm.adType) {
        result = result.filter(item => item.adType === this.filterForm.adType)
      }
      
      if (this.filterForm.keyword) {
        const keyword = this.filterForm.keyword.toLowerCase()
        result = result.filter(item => 
          (item.name && item.name.toLowerCase().includes(keyword)) ||
          (item.slotId && String(item.slotId).toLowerCase().includes(keyword))
        )
      }
      
      return result.length
    }
  },
  methods: {
    ...mapActions([
      'fetchMediaSlots',
      'createMediaSlot',
      'updateMediaSlot',
      'deleteMediaSlot'
    ]),
    handleFilter() {
      this.currentPage = 1 // 重置到第一页
    },
    resetFilter() {
      this.filterForm = {
        platform: '',
        adType: '',
        keyword: ''
      }
      this.currentPage = 1 // 重置到第一页
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleEdit(row) {
      this.isEdit = true
      this.mediaSlotForm = JSON.parse(JSON.stringify(row))
      this.addDialogVisible = true
    },
    handleDelete(row) {
      this.currentMediaSlot = row
      this.deleteDialogVisible = true
    },
    toggleStatus(slot) {
      // 注意：此时slot.status已经被Vue更新为新值，不需要再取反
      const updatedSlot = {...slot}; // 创建完整数据副本
      
      console.log('正在更新代码位状态:', updatedSlot.name, updatedSlot.status);
      
      // 调用更新API
      this.updateMediaSlot({
        id: updatedSlot.id,
        data: updatedSlot
      }).then(() => {
        this.$message.success(`代码位已${updatedSlot.status === 'active' ? '启用' : '停用'}`);
      }).catch(error => {
        // 如果API失败，需要恢复原状态
        slot.status = slot.status === 'active' ? 'inactive' : 'active';
        this.$message.error(`状态更新失败: ${error.message}`);
      });
    },
    submitMediaSlot() {
      this.$refs.mediaSlotForm.validate((valid) => {
        if (valid) {
          // 创建完整数据副本
          const formData = {...this.mediaSlotForm};
          
          // 处理JSON配置格式
          if (formData.config && typeof formData.config === 'string') {
            try {
              const configObj = JSON.parse(formData.config);
              formData.config = configObj;
            } catch (e) {
              // 如果不是有效的JSON，保留原始字符串
              console.warn('配置不是有效JSON:', e);
            }
          }
          
          // 系统自动生成代码位ID
          if (!this.isEdit) {
            formData.id = uuidv4(); // 生成唯一ID
            formData.slotId = Math.floor(new Date().getTime() / 1000); // 使用时间戳作为整数ID
            formData.createTime = new Date().toISOString();
          } else {
            // 确保编辑时slotId是整数
            if (formData.slotId && typeof formData.slotId === 'string') {
              formData.slotId = parseInt(formData.slotId, 10);
              if (isNaN(formData.slotId)) {
                formData.slotId = Math.floor(new Date().getTime() / 1000);
              }
            }
          }
          
          console.log('提交代码位数据:', formData);
          
          if (this.isEdit) {
            this.updateMediaSlot({
              id: formData.id,
              data: formData
            }).then(() => {
              this.addDialogVisible = false;
              this.$message.success('代码位更新成功');
            }).catch(error => {
              this.$message.error(`更新失败: ${error.message}`);
            });
          } else {
            this.createMediaSlot(formData).then(() => {
              this.addDialogVisible = false;
              this.$message.success('代码位添加成功');
            }).catch(error => {
              this.$message.error(`添加失败: ${error.message}`);
            });
          }
        } else {
          this.$message.warning('请完整填写必填信息');
        }
      });
    },
    confirmDelete() {
      this.deleteMediaSlot(this.currentMediaSlot.id).then(() => {
        this.deleteDialogVisible = false
        this.$message.success('代码位删除成功')
      }).catch(error => {
        this.$message.error(`删除失败: ${error.message}`)
      })
    },
    resetForm() {
      if (this.$refs.mediaSlotForm) {
        this.$refs.mediaSlotForm.resetFields();
      }
      
      this.mediaSlotForm = {
        id: '',
        name: '',
        platform: '',
        adType: '',
        slotId: '',
        bidFloor: 0,
        status: 'active',
        config: '',
        createTime: ''
      };
    },
    getPlatformName(platform) {
      const platformItem = this.platformOptions.find(item => item.value === platform);
      return platformItem ? platformItem.label : platform;
    },
    getAdTypeName(adType) {
      const adTypeItem = this.adTypeOptions.find(item => item.value === adType);
      return adTypeItem ? adTypeItem.label : adType;
    },
    getPlatformTagType(platform) {
      const platformMap = {
        'tencent': 'success',
        'bytedance': 'primary',
        'baidu': 'info',
        'kuaishou': 'warning',
        'alibaba': 'danger',
        'xiaomi': 'info',
        'oppo': 'success',
        'vivo': 'primary',
        'huawei': 'warning',
        'sohu': '',
        'meishu': '',
        'shunfei': '',
        'zhangyue': '',
        'wifi_key': '',
        'xiaohongshu_article': 'danger',
        'wechat_article': 'success',
        'self_media_article': 'warning',
        'portal_article': 'info',
        'other': ''
      };
      return platformMap[platform] || '';
    },
    getAdTypeTagType(adType) {
      const adTypeMap = {
        'banner': '',
        'native': 'success',
        'interstitial': 'info',
        'rewarded_video': 'danger',
        'splash': 'warning',
        'draw': 'primary',
        'soft_article': 'warning'
      };
      return adTypeMap[adType] || '';
    }
  },
  created() {
    this.fetchMediaSlots();
  },
  watch: {
    addDialogVisible(val) {
      if (!val) {
        // 对话框关闭时重置表单
        this.resetForm();
        this.isEdit = false;
      }
    }
  }
}
</script>

<style scoped>
.media-slot-list {
  padding: 20px 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-weight: normal;
}

.page-header p {
  margin: 5px 0 0;
  color: #909399;
}

.filter-container {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.warn-text {
  color: #f56c6c;
  font-weight: bold;
}

.el-form-item__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 3px;
}
</style>
